import { ILink } from '~/lib/data-contract';
import { usePage } from '~/templates/pages/hooks/usePage';

export const useHomeUrl = (homeLink?: ILink) => {
	const { culture, market } = usePage();

	return homeLink?.url || `/${culture}/${market}`;
};
